// Slow editorial marquee (CSS animation, respects reduced-motion via index.css).
export default function Marquee({ items }) {
  const content = items || [
    "Diskrete Haushaltsauflösung",
    "Fachgerechte Entsorgung",
    "Zuverlässige Umzüge",
    "Besenreine Übergabe",
    "Strukturierte Abwicklung",
  ];
  const line = [...content, ...content];

  return (
    <div
      className="relative w-full overflow-hidden border-y border-dark-gray bg-brand-black py-6 no-scrollbar"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {line.map((text, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-heading text-2xl font-bold uppercase tracking-tight text-light-gray/80 md:text-3xl">
              {text}
            </span>
            <span className="h-2 w-2 rounded-full bg-yellow" />
          </span>
        ))}
      </div>
    </div>
  );
}
